import React from 'react';
import { List, ListItem, Typography } from '@mui/material';

const summaryData = [
  { label: 'Member', value: '45' },
  { label: 'Members Worked', value: '20' },
  { label: 'Projects Worked', value: '4', color: '#179045' },
  { label: 'Total Worked Time', value: '15375:20:01', color: '#179045' },
  { label: 'Avg. Hours Per Member', value: '9:13:29' },
  { label: 'Avg. Hours Per Day', value: '9:13:29' },
  { label: 'Avg. Activity', value: '42%' },
  { label: 'Total Idea time', value: '20:47:30' },
  { label: 'Total Spent', value: '$358.08', color: '#0076FE' },
  { label: 'Total earned', value: '$358.08', color: '#0076FE' },
  { label: 'Amount', value: '$1,638.53', color: '#0076FE' },
  { label: 'Amount Spent', value: '$1,638.53', color: '#0076FE' },
  { label: 'Amount Earned', value: '$300.53', color: '#0076FE' },
  // Manual Time
  { label: 'Affected members', value: '8', },
  { label: 'Total  Added  Hours', value: '0:10:05', color: '#0076FE' },
  { label: 'Total Deleted Hours', value: '1:00:00', color: '#FE5857' },
  { label: 'Payments', value: '1:00:00', },
];

const SummaryList = ({ showLabels = [], overrideToDashLabels = [] }) => {
  const filteredData =
    showLabels.length > 0
      ? summaryData.filter(item => showLabels.includes(item.label))
      : summaryData;

  return (
    <>
    
      <List
        className="card-body  bg-base border rounded-3"
        sx={{ p: 0, display: 'flex', m: 0 }}
      >
        {filteredData.map((item, index) => (
          // <ListItem className='my-12 mx-12'  
          <ListItem className=''
            key={index}
            sx={{
              display: 'block',
              borderLeft: index !== 0 ? '1px solid #DFDFDF' : 'none', padding: {xl: '16px 16px' , lg: '16px 16px' , md: '16px 16px' , sm: '16px 6px' , xs: '16px 16px'}
            }}
          >
            <Typography className='fw-medium text-secondary-light text-sm' variant="body2" sx={{ fontSize: '14px' }}>{item.label}</Typography>
            <Typography
              variant="h6"
              sx={{ color: item.color || '#373737', fontWeight: 600, fontSize: {  xs: '20px', sm: '20px',  md: '24px', lg: '24px', xl: '24px',   }, }}
            >
              {overrideToDashLabels.includes(item.label) ? '-' : item.value || '-'}
            </Typography>
          </ListItem>
        ))}
      </List>
    </>

  );
};


export default SummaryList;
